import { ModalProps } from "@commonlibs";

export enum AddPointFormDataKeys {
    amount = "amount",
}
export interface AddPointFormData {
    [AddPointFormDataKeys.amount]: string;
}

export interface AddPointModalProps extends ModalProps {
    className?: string;
    style?: React.CSSProperties;
}
